import React, { useEffect, useRef } from 'react';
import { QuoteConfirmation } from './QuoteConfirmation';
import { QuoteForm } from './QuoteForm';
import { useQuoteForm } from '../../hooks/useQuoteForm';
export function QuoteRequestPanel() {
  const form = useQuoteForm();
  const cardRef = useRef<HTMLDivElement>(null);
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    cardRef.current?.scrollIntoView({
      behavior: reduce ? 'auto' : 'smooth',
      block: 'start'
    });
    if (!form.submitted) {
      window.setTimeout(() => document.getElementById('quote-form-heading')?.focus({
        preventScroll: true
      }), 0);
    }
  }, [form.submitted]);
  return <div ref={cardRef} className="scroll-mt-28 border border-line bg-paper-bright p-6 sm:p-8 md:p-10" data-id="element-239" data-mp="31d26mghw1lmn">
      {form.submitted ? <QuoteConfirmation values={form.values} fileCount={form.files.length} onReview={form.reviewForm} data-id="element-240" data-mp="2wgbsvztk324e" /> : <QuoteForm form={form} data-id="element-241" data-mp="1tyk7606cdeu0" />}
    </div>;
}